// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "cafc52b5" + "." + "1a0f5367c9875b61" + ".js";
};